import React from "react";

export default function privacyPolicyHtml() {
  return (
    <div style={{ marginBottom: "60px" }}>
      <h3>
        <strong>1. Premessa</strong>
      </h3>
      <p>
        Tourist Wallet aiuta i suoi utenti a vivere al meglio le proprie
        esperienze turististiche, verificando l’attendibilità delle recensioni e
        garantendo gli acquisti nel circuito delle attività commerciali
        aderenti, grazie ad alcune innovazioni tecniche che la rendono la
        community più autorevole al mondo nel mercato delle esperienze
        enogastronomiche e di ospitalità .
        <br />
        <br />
        Per ottenere questo risultato, è naturalmente necessario che Tourist
        Wallet chieda ai suoi utenti determinate informazioni, senza le quali la
        veridicità ed attendibilità del servizio non potrebbe raggiungere i
        risultati promessi!
        <br />
        <br />
        Ecco allora che la nostra privacy policy si occupa di spiegare
        all’utente quali tipi di dati vengono raccolti da Tourist Wallet e che
        uso viene fatto degli stessi. Utilizzando il sito web o l’app per
        mobile, l’utente dichiara di aver letto accuratamente ed aver accettato
        le citate policy, che rimangono a disposizione dell’utente, per
        successive comunicazioni, grazie agli appositi link raggiungibili da
        ogni pagina del sito web.
        <br />
        <br />
        La nostra normativa è valida per tutti i brand, i prodotti e i servizi
        di Tourist Wallet che non prevedono una propria normativa sulla privacy
        o che rimandano alla presente normativa, di seguito definiti “servizi di
        Tourist Wallet” o “Servizi”.
        <br />
        <br />
        Pertanto, preghiamo gli utenti di prenderne visione periodicamente,
        anche al fine di verificare eventuali aggiornamenti o revisioni che si
        dovessero rendere necessari. In ogni caso, sarà posto in essere ogni
        ragionevole sforzo da parte di Tourist Wallet – a mezzo avvisi pop-up,
        banner temporanei o tramite e-mail −per informare gli utenti dei
        cambiamenti della presente policy e dar loro l’opportunità di modificare
        o cancellare la propria registrazione a touristwallet.it.
        <br />
        <br />
        Per qualsiasi chiarimento, è peraltro possibile contattare direttamente
        Tourist Wallet, utilizzando i recapiti pubblicati sul sito o scrivendo
        all’apposito indirizzo mail: social@touristwallet.it
      </p>
      <h3>
        <strong>2. Titolare e responsabile del trattamento</strong>
      </h3>
      <p>
        Il titolare del trattamento dei dati è: Tourist Wallet – Via Giacomo
        Peroni, 402, 00131 Roma RM.
        <br />
        <br />
        Il responsabile della protezione dei dati è Mashfrog Group, contattabile
        al recapito social@touristwallet.it
      </p>
      <h3>
        <strong>3. Basi legali per il trattamento dei dati</strong>
      </h3>
      <p>
        Raccogliamo e conserviamo i dati in nostro possesso in modo coerente con
        il consenso concesso, che può essere revocato in qualsiasi momento
        contattando il team di assistenza di Tourist Wallet all’indirizzo e-mail
        social@touristwallet.it o utilizzando i recapiti presenti in calce al
        sito web www.touristwallet.it , nella sezione “Contattaci”.
      </p>
      <h3>
        <strong>4. Finalità della raccolta</strong>
      </h3>
      <p>
        I dati personali forniti dall’Utente verranno trattati per le seguenti
        finalità:
        <br /> – fruizione del contenuto del sito web/app per mobile;
        <br /> – fornitura delle procedure e dei servizi connessi all’utilizzo
        del sito web/app per mobile;
        <br /> – servizi di prenotazione e di ordini per consegna a domicilio;
        <br /> – servizi di pagamento;
        <br /> – invio di materiale informativo, commerciale e newsletter;
        <br /> – indagini di opinione e statistiche in forma anonima;
        <br /> – tutti gli usi consentiti dalla legge in materia di trattamento
        dei dati personali.
      </p>
      <h3>
        <strong>5. Modalità e luogo della raccolta</strong>
      </h3>
      <p>
        Il trattamento dei dati è effettuato secondo le seguenti modalità:
        mediante sistema informatizzato al quale ha accesso solo il personale
        tecnico dell’Ufficio incaricato del trattamento, che si avvale dei
        medesimi sistemi di protezione sull’accesso delle reti e degli stessi
        meccanismi di protezione sull’accesso locale adottati da Tourist Wallet
        per la tutela del proprio know-how.
        <br />
        <br />
        I dati personali sono inoltre trattati per il tempo strettamente
        necessario a conseguire gli scopi per cui sono stati raccolti.
        Specifiche misure di sicurezza sono osservate per prevenire la perdita
        dei dati, usi illeciti o non corretti ed accessi non autorizzati.
        <br />
        <br />I trattamenti dei dati personali connessi ai servizi di Tourist
        Wallet hanno luogo presso la sede della Società, sita in Via Giacomo
        Peroni, 402, 00131 Roma RM.
      </p>
      <h3>
        <strong>6. Quali sono le informazioni che raccogliamo?</strong>
      </h3>
      <p>
        Al riguardo, occorre preliminarmente distinguere tra i dati ricevuti da
        un utente registrato e i dati ottenuti da un utente non registrato, che
        sono qualitativamente e quantitativamente diversi. Ed occorre altresì
        specificare che detta distinzione è valida relativamente all’utilizzo
        della sola versione web di Tourist Wallet, posto che l’app per mobile −
        per poter essere utilizzata − presuppone la previa registrazione.
        <br />
        <br />
        <strong>Utente non registrato</strong>
        <br />{" "}
        <strong>
          Utente registrato Utente che effettua il log-in tramite Facebook
        </strong>
        <br />
        <strong>
          {" "}
          Utente che accede ai servizi di prenotazione, ordine e pagamento con
          conseguente consegna a domicilio{" "}
        </strong>
      </p>
      <h3>
        <strong>7.Profilo in modalità “privata” dell’utente</strong>
      </h3>
      <p>
        Tourist Wallet consente agli utenti di impostare i propri profili in
        modalità “privata” e, quindi, di scegliere che nel proprio profilo siano
        visibili ‘a chiunque’ solo pochissime informazioni. In particolare,
        saranno visibili a tutti: l’immagine di profilo (avatar) e quella di
        copertina, il numero di persone che seguono un utente (esclusivamente il
        numero, e non la lista per esteso dei followers), il numero di persone
        che un utente segue (esclusivamente il numero, e non la lista per esteso
        dei seguiti), il contatore delle recensioni, il contatore delle
        immagini, il contatore dei badge, il contatore dei favoriti ed il
        contatore dei check-in.
        <br />
        <br />
        Quando un nuovo utente fa richiesta ad un utente con profilo in modalità
        privata di seguirlo, a quest’ultimo perverrà una notifica che consente
        alternativamente di accettare, rifiutare o lasciare in sospeso la
        richiesta del primo utente.
        <br />
        <br />
        Tuttavia, se l’utente effettua dei check-in o pubblica delle
        recensioni/foto, queste attività vengono automaticamente pubblicate
        nelle pagine dei locali a cui si riferiscono, dove risulteranno visibili
        a tutti, a prescindere dalla modalità privata o meno del profilo
        dell’utente che le ha effettuate. Sono sempre pubbliche anche le
        attività che l’utente compie all’interno della timeline (per esempio, il
        commento in calce alla foto di un altro utente).
        <br />
        <br />
        Per impostare il proprio profilo in modalità privata l’utente potrà
        accedere alle impostazioni dell’applicazione e nella sezione “Privacy
        del profilo” attivare la modalità desiderata.
      </p>
      <h3>
        <strong>8. Marketing</strong>
      </h3>
      <p>
        Tourist Wallet potrebbe utilizzare l’indirizzo e-mail dell’utente,
        ottenuto in fase di registrazione, per contattarlo periodicamente al
        fine di inviargli notizie, di comunicargli informazioni importanti su
        Tourist Wallet o di chiedergli una valutazione del sito.
        <br />
        <br />
        Oltre a questo tipo di comunicazioni, dietro acquisizione di specifico,
        preventivo, libero e facoltativo consenso, l’utente potrà altresì essere
        contattato via e-mail e/o via telefono per operazioni di natura
        commerciale/promozionale/pubblicitaria, nonché per lo svolgimento di
        ricerche di mercato.
        <br />
        <br />
        Se non vuoi che utilizziamo i tuoi dati per questa finalità, puoi in
        qualsiasi momento modificare il tuo consenso all’invio di questo tipo di
        contatti da parte di Tourist Wallet accedendo al link posto in calce ad
        ogni e-mail ricevuta.
        <br />
        <br />
        In ogni caso, l’utente che non voglia più ricevere comunicazioni di
        natura commerciale e non riesca autonomamente a disattivarne la
        ricezione, può sempre contattare il team di assistenza predisposto da
        Tourist Wallet all’indirizzo e-mail: social@touristwallet.it
      </p>
      <h3>
        <strong>9.Notifiche da parte dell’App di Tourist Wallet</strong>
      </h3>
      <p>
        Anche Tourist Wallet utilizza le cosiddette “push notification”! Si
        tratta delle notifiche che appaiono sul cellulare dell’utente quando gli
        utenti interagiscono tra loro all’interno dell’App.
        <br />
        <br />
        Per esempio, quando un utente considera utile una recensione – e,
        quindi, clicca sul simbolo del pollice alzato in calce alla stessa −
        all’autore della recensione arriva una notifica sul cellulare a
        segnalazione di tale attività. Oppure, sempre a titolo esemplificativo,
        quando un utente avvia un check-in, la sua compiuta effettuazione viene
        segnalata agli utenti da una apposita notifica.
        <br />
        <br /> Il consenso dell’utente al ricevimento delle notifiche viene
        richiesto da Tourist Wallet in fase di installazione dell’App e può in
        ogni momento essere revocato da parte dell’utente. A tal fine, l’utente
        potrà accedere alle impostazioni del proprio telefono cellulare, nella
        sezione dedicata alla gestione delle notifiche, e deselezionare l’App di
        Tourist Wallet dall’elenco delle App autorizzate ad inviare notifiche.
      </p>
      <h3>
        <strong>10. Facoltatività del conferimento dei dati</strong>
      </h3>
      <p>
        A parte quanto specificato per i dati di navigazione e per i dati
        acquisiti in fase di registrazione (nome utente o user id o nome
        visualizzato, indirizzo e-mail, immagine del profilo e password) − senza
        i quali touristwallet.it non potrebbe funzionare propriamente e che
        pertanto costituiscono il nocciolo duro dei cd. ‘dati obbligatori’ − per
        il resto, l’utente è sempre libero di fornire o meno propri ulteriori
        dati personali.
        <br />
        <br /> Anche rispetto ai dati obbligatori, Tourist Wallet ricorda ai
        suoi utenti che essi hanno sempre la facoltà di impostare un’immagine
        del profilo di default ed un nome utente creato in maniera random dal
        sistema. <br />
        <br />È chiaro che in base alla quantità/qualità dei dati personali
        forniti e/o dei cookies accettati, i servizi resi da Tourist Wallet
        saranno più o meno performanti.
        <br />
        <br />
        Un’eccessiva riduzione della quantità/qualità dei dati conferiti
        potrebbe portare ad una esperienza insoddisfacente per l’utente e ad un
        pregiudizio per Tourist Wallet, che si prefigge l’audace obiettivo di
        abbattere il mondo delle fake review e che, a tal fine, ha bisogno di
        determinate informazioni, senza le quali non potrebbe verificare
        l’attendibilità degli utenti.
      </p>
      <h3>
        <strong>
          11. Diritti dell’utente. Conservazione, rimozione e rettifica delle
          informazioni. Eliminazione dell’account
        </strong>
      </h3>
      <p>
        Le informazioni personali associate all’account dell’utente sono
        conservate da Tourist Wallet fino alla richiesta di eliminazione
        dell’account. <br />
        <br />
        In ogni caso, l’utente può in ogni tempo esercitare taluni diritti nei
        confronti del titolare del trattamento, ai sensi degli artt. 15-22 del
        Regolamento (UE) 2016/679, ed in particolare:
        <br />
        <br /> – l’utente ha diritto di revocare il consenso al trattamento dei
        propri dati personali in precedenza accordato per una o più finalità
        specifiche, in qualsiasi momento;
        <br /> – l’utente ha diritto di accedere ai propri dati personali;
        <br /> – l’utente ha diritto di ottenere informazioni sull’origine dei
        dati personali, sulle finalità e modalità del trattamento, sulla logica
        applicata in caso di trattamento effettuato con l’ausilio di strumenti
        elettronici, degli estremi identificativi del titolare, dei responsabili
        e degli incaricati al trattamento;
        <br /> – l’utente ha diritto di opporsi, in tutto o in parte, per motivi
        legittimi, al trattamento dei propri dati personali;
        <br /> – l’utente ha diritto di opporsi al trattamento dei propri dati
        per il marketing diretto, cliccando sull’apposito link di annullamento
        dell’iscrizione contenuto in tali comunicazioni;
        <br /> – l’utente ha diritto di ottenere l’aggiornamento dei dati che lo
        riguardano, la rettificazione ovvero, quando vi ha interesse,
        l’integrazione degli stessi; parimenti egli ha diritto alla
        cancellazione o alla limitazione del trattamento dei propri dati
        personali;
        <br /> – l’utente ha diritto, a determinate condizioni, di ricevere in
        un formato strutturato, di uso comune e leggibile da dispositivo
        automatico i dati personali che lo riguardano forniti a un titolare del
        trattamento e ha il diritto di trasmettere tali dati a un altro titolare
        del trattamento senza impedimenti da parte del titolare del trattamento
        cui li ha forniti alla portabilità dei dati, cd. diritto alla
        portabilità dei dati;
        <br /> – l’utente ha diritto di proporre reclamo all'autorità di
        controllo.
        <br />
        <br /> Tourist Wallet comunica le azioni intraprese in risposta alla
        richiesta formulata dall’utente in base agli artt. 15-22 del Regolamento
        (UE) 2016/679 senza ingiustificato ritardo e, comunque, al più tardi
        entro un mese dal ricevimento della richiesta stessa. In via
        eccezionale, tale termine può essere prorogato di due mesi tenuto conto
        della complessità e del numero delle richieste. Tourist Wallet informa
        l’utente di tale proroga, e dei motivi del ritardo, entro un mese dal
        ricevimento della richiesta. Se l’interessato presenta la richiesta
        mediante mezzi elettronici, le informazioni sono fornite, ove possibile,
        con mezzi elettronici, salvo diversa indicazione dell’interessato.{" "}
        <br />
        <br />
        Chiaramente, Tourist Wallet soddisferà ogni richiesta dell’interessato
        ai sensi degli artt. 15-22 del Regolamento (UE) 2016/679, ma anche nei
        casi di segnalazione per furto d’identità o per contenuti inopportuni,
        previa verifica della sua identità.
        <br />
        <br /> A tal fine, verrà sempre richiesta all’utente l’esibizione di una
        copia del proprio documento di identità (in corso di validità), che sarà
        poi cancellata entro 30 giorni dalla ricezione.
        <br />
        <br /> DIRITTO ALLA CANCELLAZIONE DEI DATI PERSONALI (cd. ‘diritto
        all’oblio’) Come si è detto, l’utente ha diritto alla cancellazione dei
        propri dati personali, quando sussistono i motivi indicati dell’art. 17,
        lett. a-f, Regolamento (UE) 2016/679. Per esempio quando:
        <br />
        <br /> – non sono più necessari rispetto alle finalità per le quali sono
        stati raccolti o trattati;
        <br /> – l’utente ha revocato il consenso (nel caso in cui il
        trattamento dei dati personali era soggetto al solo consenso e non
        esistano ulteriori basi giuridiche); <br />– l’utente si è opposto al
        trattamento dei propri dati personali e Tourist Wallet non ha motivi
        legittimi prevalenti per continuare;
        <br /> – i dati personali sono stati trattati illecitamente;
        <br /> – i dati personali devono essere eliminati in ottemperanza a
        determinati obblighi di legge. <br />
        <br />
        Se si desidera cancellare il proprio account, è possibile contattare
        l’assistenza di Tourist Wallet (utilizzando i recapiti pubblicati sul
        sito o inviando una e-mail all’indirizzo social@touristwallet.it)
        <br />
        <br /> Tourist Wallet invierà all’utente una e-mail di conferma della
        presa in carico della richiesta di cancellazione. Una volta ricevuta
        questa conferma, Tourist Wallet verificherà l’identità del richiedente e
        sarà pertanto richiesto l’invio di una copia di un documento di identità
        (in corso di validità), che verrà poi cancellata entro 30 giorni dalla
        ricezione.
        <br />
        <br /> Il processo di eliminazione sarà avviato senza ingiustificato
        ritardo: l’account dell’utente e le attività da questi pubblicate, come
        foto e check-in non saranno più recuperabili.
        <br />
        <br /> Peraltro, Tourist Wallet si riserva di conservare determinate
        informazioni a seguito della richiesta di cancellazione dell’account
        dell’utente per il periodo strettamente necessario ai fini
        dell’accertamento, dell’esercizio o della difesa di un diritto in sede
        giudiziaria, per adempiere ad obblighi di legge o quando, ad esempio, il
        trattamento si riveli necessario per l’esercizio del diritto alla
        libertà di espressione e d'informazione.
      </p>
      <h3>
        <strong>12. Misure di sicurezza implementate</strong>
      </h3>
      <p>
        Tourist Wallet ha implementato procedure di sicurezza per la protezione
        delle informazioni personali conservate nei suoi sistemi. <br />
        <br />
        Oltre a limitare l’accesso alle informazioni personali al solo personale
        tecnico che deve inevitabilmente accedere ad esse, Tourist Wallet
        impiega anche processi – come l’hashing delle password o la conclusione
        di sessioni inattive − per proteggere queste informazioni da accessi non
        autorizzati. <br />
        <br />
        Non solo. La piattaforma si serve di firewall per impedire a persone a
        terzi di accedere alle informazioni degli utenti e di crittografia
        (utilizziamo il protocollo https e la tecnologia dei cd. token per
        stabilire le connessioni tra i dispositivi e il server.
      </p>
      <h3>
        <strong>13. Privacy degli utenti minori di età</strong>
      </h3>
      <p>
        Tourist Wallet offre un servizio rivolto a un pubblico generico, tra cui
        vi sono in prima linea le famiglie. Tuttavia Tourist Wallet non fornisce
        servizi ai bambini. Non può e non intende raccogliere dati personali di
        bambini. L’utente, utilizzando il sito web e l’app per mobile, e
        accettando la presente policy, dichiara di aver compiuto il sedicesimo
        anno di età conformemente a quanto disposto dall’art. 8 del Regolamento
        (UE) 2016/679. In ogni caso, utilizzando il sito web e l’app per mobile,
        ed accettando la presente policy, l’utente che risieda in uno Stato non
        membro dell’Unione europea dichiara di aver raggiunto il limite legale
        di maggior età, ai sensi dell’ordinamento giuridico di riferimento.
        <br />
        <br /> Tourist Wallet invita i genitori a sensibilizzare i propri figli
        circa le regole da adottare per un utilizzo sicuro di Internet e
        soprattutto invita ad un maggiore controllo rispetto alle applicazioni
        per mobile, facilmente scaricabili, anche da un bambino, negli appositi
        app-store.
      </p>
      <h3>
        <strong>14. Modifiche alla presente privacy policy</strong>
      </h3>
      <p>
        Tourist Wallet potrebbe modificare questa policy nel caso in cui
        sopravvenissero interventi normativi. In caso di modifiche che
        potrebbero avere effetti sulle informazioni raccolte dall’utente, sarà
        posto in essere ogni ragionevole sforzo – a mezzo avvisi pop-up, banner
        temporanei o tramite e-mail −per informare gli utenti dei cambiamenti e
        dar loro l’opportunità di modificare o cancellare la propria
        registrazione.
      </p>
    </div>
  );
}
